export enum MessageType {
  AI_MESSAGE = "aiMessage",
  CHARACTER_PHOTOS_UPLOADED = "characterPhotosUploaded",
  ERROR_MESSAGE = "errorMessage",
  NEW_CONVERSATION = "newConversation",
  NOTIFICATION = "notification",
  PERFORMER_CONTRACT_DECLINED = "performerContractDeclined",
  SUPPORT_MESSAGE = "supportMessage",
  SYSTEM_MESSAGE = "systemMessage",
  /** Ephemeral typing-indicator ping — never persisted as a ChatMessage row. */
  TYPING = "typing",
  UPDATED_CONVERSATION = "updatedConversation",
  USER_MESSAGE = "userMessage",
}

export enum ConversationStatus {
  OPEN = "open",
  CLOSED = "closed",
}

export enum ConversationType {
  SUPPORT = "support",
  TALENT_MANAGER = "talentManager",
  PROJECT = "project",
}

export enum ConversationParticipantRole {
  AGENCY = "agency",
  TALENT_MANAGER = "talentManager",
  SUPPORT = "support",
  ADMIN_OBSERVER = "adminObserver",
}

export enum MentionTargetType {
  USER = "user",
  BOT = "bot",
  SUPPORT = "support",
}

export type TNotificationPreferences = {
  emailOnMention: boolean;
};
